import React from "react";
import ClientList from "./ClientList";

const ClientManagement = () => {
  return <ClientList />;
};

export default ClientManagement;
